import { GEO } from '@/const/cookies';
import { config } from '@/pageConfig/pet/pet/us/en';
import { PetPageTemplate } from '@/pageTemplate/PetPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

export default function PetPage() {
  const [cookies] = useCookies([GEO]);
  const { trackEvent } = useAnalyticsContext();
  const { country, region, city } = cookies[GEO] || {};

  useEffect(() => {
    trackEvent('pet_landing_page.viewed', {
      experiment: 'bottom_sticky_cta_off',
      pet_lp_type: 'default',
      variant: 'default',
      country,
      region,
      city,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PetPageTemplate config={config} />;
}
